var CableBuilderStart = function ($container, search, next) {
    CableBuilderStep.call(this, $container, search, next)
}

CableBuilderStart.prototype = Object.create(CableBuilderStep.prototype)
